
module.config(function($stateProvider, TagUrl, moment) {

    var currentAmcYear = moment().add(2, 'months').year() - 1,
        fieldUrl = new TagUrl().addTagTypes(['program', 'location', 'participant'])
            .setTagDefault('slot-gy', currentAmcYear.toString()),
        programUrl = new TagUrl()
            .addTagType('participant')
            .setTagDefault('slot-gy', currentAmcYear.toString());

    $stateProvider.state('program.reports.amc', {
        url: '/amc', abstract: true, templateUrl: 'empty'});
    $stateProvider.state('reports.amc', {
        url: '/amc', abstract: true, templateUrl: 'empty'});

    function makeState(url, template) {
        return {
            url: url.buildUrl('/hours?{page}&{sort}&{direction}'),
            params: url.params,
            permission: 'viewAmericorpsSlots',
            templateUrl: 'reports/amc/' + template,
            data: {tagUrl: url},
            reloadOnSearch: false,
            controller: 'AmericorpsHoursReportController',
        }
    }

    $stateProvider.state('program.reports.amc.hours',
                         makeState(programUrl, 'programHours'));

    $stateProvider.state('reports.amc.hours',
                         makeState(fieldUrl, 'hours'))


});


module.controller('AmericorpsHoursReportController', function(
        $scope, AmericorpsHoursReport, AmericorpsMemberReport) {

    $scope.report = new AmericorpsHoursReport($scope.program);
    $scope.members = new AmericorpsMemberReport($scope.program);

    $scope.refresh = function(params) {
        $scope.report.update(params);
        $scope.members.update(params);
    };

    $scope.slotParams = function(slot) {
        return {
            type: slot.has_enrollment ? 'student' : 'participant',
            id: slot.participant_id,
            slotId: slot.slot_id,
        };
    };

    $scope.programParams = function(slot) {
        var params = angular.copy($scope.report.params);
        params.slug = slot.slug;
        return params;
    };

    $scope.statusNames = {
        earned: 'Earned Ed Award',
        finished: 'Hours Completed',
        canceled: 'Slot Canceled',
        on_track: 'On Track',
        not_on_track: 'Not on Track',
        not_started: 'Not Started',
    }
});


module.service('AmericorpsHoursReport', function(Report) {

    Report.makeChildClass(AmericorpsHoursReport);

    function AmericorpsHoursReport(program) {
        var url = ['reports/amc/hours'];
        if (program) url.push(program.id);
        Report.call(this, url);
    }

    Report.addPercentColumns(AmericorpsHoursReport, {
        earning: ['earning', 'count'],
        onTrack: ['on_track', 'earning'],
        inDanger: ['in_danger', 'earning'],
        completed: ['completed', 'count'],
        edAward: ['ed_award', 'count'],
        field: ['field_ed_award', 'field_count'],
    });

    return AmericorpsHoursReport;
});


module.service('AmericorpsMemberReport', function(Report) {

    Report.makeChildClass(AmericorpsMemberReport, {
        isList: true,
        sorter: {
            default: 'name',
            direction: 'asc',
            columns: ['name', 'slot_type', 'start_date', 'hours', 'status', 'issue'],
        }
    });

    function AmericorpsMemberReport(program) {
        var url = ['reports/amc/members'];
        if (program) url.push(program.id);
        Report.call(this, url);
    }

    return AmericorpsMemberReport;
});